import React, { useState } from 'react';
import { FormControl, Input, Box, Grid } from '@chakra-ui/react';

function PriceInputs({ prices, updatePrices, updatePricesErrors, updatePriceTouched }) {
  function getCollapsedInitialItem(prices) {
    if (!Array.isArray(prices) || prices.length === 0) {
      return { title: '', amount: '', vat: false };
    }

    if (prices.length === 1) {
      const first = prices[0] || {};
      return {
        title: first.title || '',
        amount: first.amount ?? '',
        vat: false,
      };
    }

    const title = (prices[0] && prices[0].title) || 'Fees';
    const total = prices.reduce((acc, item) => acc + (parseFloat(item?.amount) || 0), 0);
    return {
      title,
      amount: total ? total.toFixed(2) : '',
      vat: false,
    };
  }

  const collapsedInitialItem = getCollapsedInitialItem(prices);
  const [inputList, setInputList] = useState([collapsedInitialItem]);
  const [values] = useState([collapsedInitialItem]);

  function createErrorsFields(prices) {
    let list = [];
    for (let i = 0; i < prices.length; i++) {
      list[i] = { title: '', amount: '' };
    }

    return list;
  }

  const [errors, setErrors] = useState(createErrorsFields([collapsedInitialItem]));

  const validate = (fieldValues = values, index) => {
    const list = [...errors];
    if (!(index in list)) {
      list[index] = {};
    }

    // const regExp1 = /[0-9]|\./;
    // const regExp2 = /^[a-zA-Z.,;:|\\\/~!@#$%^&*_-{}\[\]()`"'<>?\s]+$/;
    // const regExp3 = /^\s*|[0-9][0-9]*/;
    // const regExp4 = /^\d+\.\d{0,2}$/;
    // const regExp5 = /^(\s*|\d+)$/; //positive numbers and allow empty string
    // https://forums.asp.net/t/1909870.aspx?Regular+expression+to+allow+a+number+upto+2+decimal+places
    const regExp6 = /^\d+(\.\d{1,2})?$/; //positive numbers and allow empty string

    if ('title' in fieldValues) {
      if (fieldValues.title === '') {
        list[index].title = 'This is mandatory field';
      } else if (fieldValues.title.length > 255) {
        list[index].title = 'Please enter 250 characters or less';
      } else {
        list[index].title = '';
      }
    }
    if ('amount' in fieldValues)
      list[index].amount = fieldValues.amount ? '' : 'This is mandatory field';
    if ('amount' in fieldValues) {
      if (fieldValues.amount === '') {
        list[index].amount = 'This is mandatory field';
      } else if (!regExp6.test(fieldValues.amount)) {
        list[index].amount =
          'Only numerical input is allowed, if decimal number is needed please use . to separate numbers (e.g. 3.14).';
      } else if (fieldValues.amount === '0') {
        list[index].amount = 'Only input larger than 0 is allowed.';
      } else {
        list[index].amount = '';
      }
    }

    setErrors(list);
    updatePricesErrors(list);
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
    updatePrices(list);
    validate({ [name]: value }, index);
    updatePriceTouched(true);
  };

  return (
    <>
      {inputList.map((x, i) => {
        return (
          <Box mb={4}>
            <Box border="1px solid #ebecf0" borderRadius="6px" p={5} position="relative">
              <Grid container templateColumns="repeat(2, 1fr)" gap={6}>
                <Grid item sm={6}>
                  <FormControl mb={0}>
                    <Input
                      isInvalid
                      name="title"
                      id="itemTitle"
                      size="lg"
                      border="1px solid  transparent"
                      bg="#ebecf0"
                      _focus={{ border: '1px solid black' }}
                      _hover={{ border: '1px solid black' }}
                      //   {...register("itemTitle")}
                      placeholder="Enter item title"
                      value={x.title}
                      onChange={(e) => handleInputChange(e, i)}
                    />
                    {errors[i]?.title?.message || errors[i]?.title ? (
                      <Box color="error.500" fontSize="13px">
                        {errors[i].title}
                      </Box>
                    ) : null}
                  </FormControl>
                </Grid>
                <Grid item sm={6}>
                  <FormControl mb={0}>
                    <Input
                      isInvalid
                      name="amount"
                      id="amount"
                      size="lg"
                      border="1px solid  transparent"
                      bg="#ebecf0"
                      _focus={{ border: '1px solid black' }}
                      _hover={{ border: '1px solid black' }}
                      //   {...register("itemTitle")}
                      placeholder="Enter net amount (ex VAT)"
                      value={x.amount}
                      onChange={(e) => handleInputChange(e, i)}
                    />
                    {errors[i]?.amount?.message || errors[i]?.amount ? (
                      <Box color="error.500" fontSize="13px">
                        {errors[i].amount}
                      </Box>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          </Box>
        );
      })}
    </>
  );
}

export default PriceInputs;
